@use "../../styles/mixins/component-wrapper" as wrapper;

@include wrapper.layered-component {
  label {
    display: inline-flex;
    align-items: flex-start;
    gap: var(--semantic-spacing-content-m-gap-plain);
    font-family: var(--semantic-font-family-utility);
    font-size: var(--semantic-font-size-utility-m);
    font-style: normal;
    font-weight: var(--semantic-font-weight-utility-attention);
    line-height: var(--semantic-line-height-utility-m);
    letter-spacing: var(--semantic-letter-spacing-utility-m);
    color: var(--semantic-color-on-surface-primary-resting);

    .label-optional {
      font-weight: var(--semantic-font-weight-utility-default);
    }

    .icon {
      font-size: var(--semantic-size-content-s);
      font-family: "Allianz Icons"; /* stylelint-disable -- Declaration of custom font. */
      font-weight: var(--semantic-font-weight-utility-default);
      color: var(--semantic-color-on-surface-secondary-resting);
      font-style: normal;

      &.icon--info-circle-o {
        &::before {
          content: "\e921";
        }
      }
    }

    &.label-disabled {
      color: var(--semantic-color-on-surface-primary-disabled);
    }
  }
}
